import type { RiskRating } from './generated/enums';

export const RISK_LEVELS = ['VERY_LOW', 'LOW', 'MEDIUM', 'HIGH', 'VERY_HIGH'] as const;
export type RiskAxisLevel = (typeof RISK_LEVELS)[number];
export const RISK_LEVEL_LABELS: Record<RiskAxisLevel, string> = {
  VERY_LOW: 'Very low', LOW: 'Low', MEDIUM: 'Medium', HIGH: 'High', VERY_HIGH: 'Very high',
};
export const RISK_LEVEL_VALUES: Record<string, number> = { VERY_LOW: 1, LOW: 2, MEDIUM: 3, HIGH: 4, VERY_HIGH: 5 };
const LEGACY_VALUE: Record<string, number> = { LOW: 1, MEDIUM: 2, HIGH: 3 };

/** Version 1 is retained only for immutable 3×3 assessment history. */
export function computeRiskScore(likelihood: string | null | undefined, impact: string | null | undefined, version = 2): number {
  const values = version === 1 ? LEGACY_VALUE : RISK_LEVEL_VALUES;
  const l = values[likelihood ?? ''] ?? 0;
  const i = values[impact ?? ''] ?? 0;
  return l && i ? Math.round(l * i / (version === 1 ? 9 : 25) * 100) : 0;
}

export function ratingFromScore(score: number, version = 2): RiskRating {
  if (score >= (version === 1 ? 76 : 80)) return 'CRITICAL';
  if (score >= (version === 1 ? 51 : 40)) return 'HIGH';
  if (score >= (version === 1 ? 26 : 20)) return 'MEDIUM';
  return 'LOW';
}

export function deriveRating(likelihood: string | null | undefined, impact: string | null | undefined, version = 2): RiskRating {
  return ratingFromScore(computeRiskScore(likelihood, impact, version), version);
}
